import { render, staticRenderFns } from "./LoyaltyBenefits.vue?vue&type=template&id=35da51cc&scoped=true&"
import script from "./LoyaltyBenefits.vue?vue&type=script&lang=js&"
export * from "./LoyaltyBenefits.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyBenefits.vue?vue&type=style&index=0&id=35da51cc&scoped=true&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35da51cc",
  null
  
)

export default component.exports